import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router';
import { useAuth } from '@/hooks/useAuth';

export function AuthCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAuthenticated, loading } = useAuth();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    // Supabase auto-detects the OAuth callback params (code/hash) in the URL
    // and exchanges them via the shared GoTrueClient in AuthContext.
    // We just wait for isAuthenticated to flip.
    if (!loading && isAuthenticated) {
      // Support redirect param for OAuth consent flow
      const redirect = searchParams.get('redirect');
      navigate(redirect || '/dashboard', { replace: true });
    }
  }, [loading, isAuthenticated, navigate, searchParams]);

  useEffect(() => {
    const timeout = setTimeout(() => setTimedOut(true), 15000);
    return () => clearTimeout(timeout);
  }, []);

  if (timedOut && !isAuthenticated) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4">
        <p className="text-sm text-error">
          Something went wrong while signing you in. Please try again.
        </p>
        <Link to="/login" className="btn btn-primary btn-sm">
          Try again
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-3">
      <span className="loading loading-spinner loading-lg" />
      <p className="text-sm text-base-content/50">Signing you in...</p>
    </div>
  );
}
